/* eslint-env browser */

const ZenDeskClient = window && window.ZAFClient && window.ZAFClient.init()

export default ZenDeskClient
